"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordRequirements = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _i18n = require("@ori/i18n");
var _components = require("../../components");
var _defaultTranslations = require("../../constants/defaultTranslations");
var _jsxRuntime = require("react/jsx-runtime");
const IconWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  marginTop: theme.spacing(1)
}));
const CheckIcon = (0, _mui.styled)(_icons.CheckCircleFilled)(({
  theme
}) => ({
  color: theme.palette.default.light,
  marginRight: theme.spacing(1)
}));
const CheckIconSuccess = (0, _mui.styled)(_icons.CheckCircleFilled)(({
  theme
}) => ({
  color: theme.palette.primary.dark,
  marginRight: theme.spacing(1)
}));
const ErrorIcon = (0, _mui.styled)(_icons.ErrorCircleFilled)(({
  theme
}) => ({
  color: theme.palette.error.dark,
  marginRight: theme.spacing(1)
}));
const StyledLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  color: theme.palette.default.main
}));
const getValidationIcon = (requirementProperty, value) => requirementProperty.validationRegex.test(value ?? '') ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckIconSuccess, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(ErrorIcon, {});
const PasswordRequirements = props => {
  const {
    requirements,
    minChar,
    actualValue,
    validating
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
    namespace: _defaultTranslations.translationsNamespace,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      children: requirements?.map(requirement => /*#__PURE__*/(0, _jsxRuntime.jsxs)(IconWrapper, {
        children: [validating ? getValidationIcon(requirement, actualValue) : /*#__PURE__*/(0, _jsxRuntime.jsx)(CheckIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
          variant: "caption",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Localization, {
            defaultMessage: _defaultTranslations.defaultTranslations[requirement.key],
            id: requirement.key,
            values: {
              min: minChar
            }
          })
        })]
      }, requirement.key))
    })
  });
};
exports.PasswordRequirements = PasswordRequirements;
//# sourceMappingURL=PasswordRequirements.js.map